import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  selector: 'app-select-busca-cliente',
  templateUrl: './select-busca-cliente.component.html',
  styleUrls: ['./select-busca-cliente.component.css']
})
export class SelectBuscaClienteComponent implements OnInit, OnChanges {
  @Input() clientes: any[] = [];
  @Input() matlabelOpcional: string = 'Cliente';
  @Input() desabilitado: boolean = false;
  @Input() exibeClienteFormulario: boolean = false;
  @Input() valorSelecionado: number = 0;
  @Output() clienteSelecionado = new EventEmitter<any>();

  placeholder: string = '';
  clientControl = new FormControl();
  clientesFiltrados$: Observable<any[]> = new Observable();
  ultimoClienteSelecionado: any = null;
  
  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  constructor() { }

  ngOnInit(): void {
    this.inicializarAutocomplete();
    
    if (this.exibeClienteFormulario) {
      this.definirClienteFormulario();
    }

    if (this.desabilitado) {
      this.clientControl.disable();
    }
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['desabilitado']) {
      if (this.desabilitado) {
        this.clientControl.disable();
      } else {
        this.clientControl.enable();
      }
    }
    
    if (changes['clientes'] || changes['valorSelecionado']) {
      setTimeout(() => {
        this.definirClienteFormulario();
      }, 0);
    }
  }

  inicializarAutocomplete(): void {
    this.clientesFiltrados$ = this.clientControl.valueChanges.pipe(
      startWith(''),
      map(value => this.filtrarClientes(value))
    );
  }

  definirClienteFormulario(): void {
    if (this.valorSelecionado && this.clientes.length > 0) {
      const cliente = this.clientes.find(c => c.id === this.valorSelecionado);
      if (cliente) {
        this.clientControl.setValue(cliente.nome, { emitEvent: false });
        this.ultimoClienteSelecionado = cliente;
      }
    }
  }

  onChange(event: any): void {
    const clienteSelecionado = event.option.value;

    if (clienteSelecionado === 'Todas as Usinas') {
      this.clienteSelecionado.emit('');
      this.clientControl.setValue('Todas as Usinas', { emitEvent: false });
      this.clientControl.setErrors(null);
      this.ultimoClienteSelecionado = 'Todas as Usinas';
      return;
    }

    if (clienteSelecionado && clienteSelecionado.id !== undefined) {
      this.clienteSelecionado.emit(clienteSelecionado.id);
      this.clientControl.setValue(clienteSelecionado.nome, { emitEvent: false });
      this.clientControl.setErrors(null);
      this.ultimoClienteSelecionado = clienteSelecionado;
    }
  }

  filtrarClientes(value: any): any[] {
    if (!value || !this.clientes) {
      return this.clientes || [];
    }
    
    const filterValue = typeof value === 'string' 
      ? value.toLowerCase() 
      : (value.nome || '').toLowerCase();
    
    return this.clientes.filter(cliente => 
      cliente.nome.toLowerCase().includes(filterValue)
    );
  }

  abrirAutocomplete(): void {
    this.clientControl.updateValueAndValidity();
  }

  limparInput(): void {
    this.clientControl.setValue('');
    this.placeholder = '';
  }

  fechar(): void {
    this.autocompleteTrigger?.closePanel();
    (document.activeElement as HTMLElement)?.blur();

    if (this.ultimoClienteSelecionado && this.ultimoClienteSelecionado !== 'Todas as Usinas') {
      this.clientControl.setValue(this.ultimoClienteSelecionado.nome, { emitEvent: false });
    } else if (this.ultimoClienteSelecionado === 'Todas as Usinas') {
      this.clientControl.setValue('Todas as Usinas', { emitEvent: false });
    }
  }

  restaurarClienteSeVazio(): void {
    if (!this.clientControl.value || this.clientControl.value.trim() === '') {
      const novoValor = this.ultimoClienteSelecionado === 'Todas as Usinas' 
        ? 'Todas as Usinas' 
        : this.ultimoClienteSelecionado?.nome;
      
      if (novoValor) {
        this.clientControl.setValue(novoValor, { emitEvent: false });
      }
    }
  }

  public getClienteSelecionado(): any {
    return this.ultimoClienteSelecionado;
  }
}